import { createHashRouter } from "react-router-dom";
import Home from "./pages/Home";
// import Call from 
import Call from "./pages/Call"; // "./pages/LiveKitCall"; // "./pages/TrtcCall";
import Login from "./pages/Login";

const router = createHashRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/call",
    element: <Call />,
  }
]);

export default router;
